/* Syd's House - homepage reviews slider.
   Seamless marquee: duplicates the cards once, then translates the track
   from 0 to -50% on a loop. Pauses on hover (desktop) and touch (mobile).
   Honours prefers-reduced-motion. */
(function () {
  var viewport = document.getElementById('sydReviews');
  var track = document.getElementById('sydReviewsTrack');
  if (!viewport || !track) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Duplicate cards once for a seamless wrap
  var originals = Array.prototype.slice.call(track.children);
  if (originals.length === 0) return;
  originals.forEach(function (node) {
    var clone = node.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  var speed = parseFloat(viewport.getAttribute('data-speed')) || 60; // seconds for a full pass
  var paused = false;
  var offset = 0;
  var lastTs = 0;
  var halfWidth = 0;

  function measure() {
    // total scrollable width is half the track (originals only)
    halfWidth = track.scrollWidth / 2;
  }
  measure();
  window.addEventListener('resize', measure);

  function frame(ts) {
    if (!lastTs) lastTs = ts;
    var dt = (ts - lastTs) / 1000;
    lastTs = ts;
    if (!paused && halfWidth > 0) {
      var pxPerSec = halfWidth / speed;
      offset += pxPerSec * dt;
      if (offset >= halfWidth) offset -= halfWidth;
      track.style.transform = 'translateX(' + (-offset) + 'px)';
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  function pause() { paused = true; }
  function resume() { paused = false; }

  viewport.addEventListener('mouseenter', pause);
  viewport.addEventListener('mouseleave', resume);
  viewport.addEventListener('touchstart', pause, { passive: true });
  viewport.addEventListener('touchend', resume, { passive: true });
  viewport.addEventListener('touchcancel', resume, { passive: true });
})();
